import script from "./Uuid.vue?vue&type=script&setup=true&lang=js"
export * from "./Uuid.vue?vue&type=script&setup=true&lang=js"

import "./Uuid.vue?vue&type=style&index=0&id=2407b902&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2407b902"]])

export default __exports__